import * as Yup from "yup";
import formModel from "./formModel";

const {
  formField: {
    theme,
    wl_primarycolor,
    n_fontcolor,
    lab_primary,
    lab_fontcolor,
    multilanguage,
    muti_currency,
    tax_value,
    tax_name,
  },
} = formModel;

const numberMatch  = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
const taxnameMatch = /^[a-zA-Z0-9-_]+$/;

export const validateThemeFormSchema = Yup.object().shape({
  [theme.name]:         Yup.string().required(theme.requiredErrorMsg),
  [wl_primarycolor.name]: Yup.string().required(wl_primarycolor.requiredErrorMsg),
  [n_fontcolor.name]:     Yup.string().required(n_fontcolor.requiredErrorMsg),
  [lab_primary.name]:     Yup.string().required(lab_primary.requiredErrorMsg),
  [lab_fontcolor.name]:   Yup.string().required(lab_fontcolor.requiredErrorMsg),
  [multilanguage.name]:   Yup.string().required(multilanguage.requiredErrorMsg),
});

export function validateTaxAndCurrencyFormSchema(taxInclusive) {
  if (taxInclusive) {
    return Yup.object().shape({
      [muti_currency.name]: Yup.string().required(muti_currency.requiredErrorMsg),
      [tax_value.name]:     Yup.string()
        .required(tax_value.requiredErrorMsg)
        .matches(
          numberMatch,
          "Tax Value must be numeric with up to 2 decimal places and greater than zero"
        ),
      [tax_name.name]:      Yup.string()
        .required(tax_name.requiredErrorMsg)
        .matches(
          taxnameMatch,
          "Only alphanumeric characters and hyphens are allowed"
        ),
    });
  }

  return Yup.object().shape({
    [muti_currency.name]: Yup.string().notRequired(),
    [tax_value.name]:     Yup.string().notRequired(),
    [tax_name.name]:      Yup.string().notRequired(),
  });
}
